// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__y9NNi","content":"Footer_content__g7j-+","head":"Footer_head__KeU8q","logo":"Footer_logo__kcgGi","mid":"Footer_mid__53hgX","foot":"Footer_foot__ZaH+Z"};